export default __webpack_public_path__ + "bb7fe2ac595877d97433e37efadd6b8b.png";